import { useState } from 'react';

import type { FormSubmitFunction } from '#/components/Form/FormContext';
import type { CmsApiEmailCampaignSignupSingleBlockData } from '#/modules/cms/api/types/blocks/CmsApiEmailCampaignSignupSingleBlock';
import { postJson } from '#/utils/http/postJson';

import { CmsEmailCampaignSignup } from './CmsEmailCampaignSignup';

type Props = {
  blockId: string;
  data: CmsApiEmailCampaignSignupSingleBlockData;
};

export function CmsEmailCampaignSignupSingleBlock({
  blockId,
  data: { headline, buttonText, bgImage },
}: Props) {
  const [mode, setMode] = useState('initial');

  const onSubmit: FormSubmitFunction<
    CmsApiEmailCampaignSignupSingleBlockData
  > = ({ values, handleError }) => {
    const postBaseUrl = '/data/website/page-email-signup-single/';
    setMode('submitting');
    postJson(postBaseUrl + blockId, values)
      .then(() => {
        setMode('submitted');
      })
      .catch((e) => {
        handleError(e);
        setMode('initial');
      });
  };

  return (
    <CmsEmailCampaignSignup
      disabled={mode === 'submitting'}
      onSubmit={onSubmit}
      headline={headline}
      buttonText={buttonText}
      isSubmitted={mode === 'submitted'}
      bgImage={bgImage}
      qaId="cms-email-campaign-signup-single"
    />
  );
}
